module.exports = __webpack_public_path__ + "static/media/3.877c9bc0.gif";